import React from 'react'
import {CAT_ORDER, CATEGORIES} from '../data/categories'
import type {CategoryKey} from '../data/types'
import {useSpendBenchmarksTracking} from '../hooks/useSpendBenchmarksTracking'

interface CategorySwitcherProps {
  currentCategory: CategoryKey
  onCategoryChange: (key: CategoryKey) => void
}

const CategorySwitcher: React.FC<CategorySwitcherProps> = ({currentCategory, onCategoryChange}) => {
  const {trackClick} = useSpendBenchmarksTracking()

  const step = (dir: number) => {
    const i = CAT_ORDER.indexOf(currentCategory)
    const next = (i + dir + CAT_ORDER.length) % CAT_ORDER.length
    onCategoryChange(CAT_ORDER[next])
    trackClick('category_arrow', {direction: dir === -1 ? 'prev' : 'next', category: CAT_ORDER[next]})
  }

  const chevronLeft = (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15 6l-6 6 6 6" />
    </svg>
  )

  const chevronRight = (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  )

  return (
    <div id="category-switcher" className="cat-switcher">
      <div className="wrap">
        <div className="switcher-label">Browse by spend category</div>

        {/* Mobile: arrow + current category name + arrow */}
        <div className="cat-mobile-nav">
          <button type="button" className="cat-arrow" aria-label="Previous category" onClick={() => step(-1)}>
            {chevronLeft}
          </button>
          <span className="cat-mobile-current">{CATEGORIES[currentCategory].label}</span>
          <button type="button" className="cat-arrow" aria-label="Next category" onClick={() => step(1)}>
            {chevronRight}
          </button>
        </div>

        {/* Desktop: full tab list + arrows */}
        <div className="cat-tabs" aria-label="Spend categories">
          {CAT_ORDER.map((key) => (
            <button
              key={key}
              type="button"
              aria-pressed={currentCategory === key}
              className={`cat-tab${currentCategory === key ? ' active' : ''}`}
              onClick={() => {
                onCategoryChange(key)
                trackClick('category_tab', {category: key})
              }}
            >
              {CATEGORIES[key].label}
            </button>
          ))}
        </div>
        <div className="cat-nav">
          <button type="button" className="cat-arrow" aria-label="Previous category" onClick={() => step(-1)}>
            {chevronLeft}
          </button>
          <button type="button" className="cat-arrow" aria-label="Next category" onClick={() => step(1)}>
            {chevronRight}
          </button>
        </div>
      </div>
    </div>
  )
}

export default CategorySwitcher
